import { createSlice } from '@reduxjs/toolkit'

// import { FALSE } from 'sass'
const slice = createSlice({
  //name: 'providerManagement',
  name: 'managePharmacy',
  initialState: {
    // pharmacy Admin
    productSubTypeListLoading: false,
    productSubTypeList: [],

    PharmacyCategoriesPaginationData: {},
    dataProductListPaginationData: {},
    updatePharmacyCategories: false,
    getWearableSizesLoading: false,
    wearableSizesList: [],
    productTypeList: [],
    productTypeListLoading: false,
    productTypeListPaginationData: {},
    updateProductTypes: false,
    drugCompositionList: [],
    drugCompositionListLoading: false,
    drugCompositionListPaginationData: {},
    updateDrugCompositionsList: false,
    updateSubTypeProductCategories: false,
    listProductCategories: [],
    listProductCategoriesLoading: false,
    dataProductList: [],
    ListProductDataLoding: false,
    updateListProductCategory: false,
    listProductCategoriesPaginationData: {},
    getOrderPharmacyList: [],
    getOrderPharmacyListLoading: false,
    getOrderPharmacyListPaginationData: false,
    eachPharmacyOrderList: [],
    eachPharmacyOrderListLoding: false,
    getProductDeatils: [],
    getProductDeatilsLoading: false,
    getEachOrderDetails: [],
    getEachOrderDetailsLoading: false,
    pharmacyDetailsList: [],
    productTypeDetailsList: [],
    productTypeDetailsListLoading: false,
    productCategoryDetailsList: [],
    productCategoryDetailsListLoading: false,
    productSubCategoryDetailsList: [],
    productSubCategoryDetailsListLoading: false,
    //pharmacyExcelLoading: false,
    pharmacyProductExcelLoading: false,
    getAllProductList: [],
    getAllProductListLoading: false,
    getAllProductListSuccess: false,
    updateProductStatus: false,
    excelProductError: [],
    excelApiCallSuccess: false,

    addProductTypeError: '',
    addProductTypeApiSuccess: false,

    addCategoryError: '',
    addCategoryApiSuccess: false,

    addSubCategoryError: '',
    addSubCategoryApiSuccess: false,

    updateProductTypeError: '',
    updateProductListSuccess: false,
    adminAddProductLoading: false,

    // Add Pharmacy By Excel through Admin
    bulkPharmacyExcelLoading: false,
    pharmacyExcelApiCallSuccess: false,
    excelBulkPharmacyError: [],

    productMedicineDetailsListLoading: false,
    productMedicineDetails: {},
    productMedicineListLoading: false,
    productMedicineList: [],
    productMedicineListPaginationData: {},
    addMedicineProductLoading: false,

    modalOpen: false,
    ApiError: '',
  },
  reducers: {
    //pages
    // pharmacy Admin

    // Pharmacy get Sub Types
    getSubProductTypeListData: (state, { payload }) => {
      state.productSubTypeListLoading = true
    },
    getSubProductTypeListSuccess: (state, { payload }) => {
      state.productSubTypeListLoading = false
      state.productSubTypeList = payload?.payload?.data

      state.PharmacyCategoriesPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getSubProductTypeListFailed: (state, { payload }) => {},

    // Add pharmacy sub types

    addSubProductTypeListData: (state, { payload }) => {
      state.updateSubTypeProductCategories = false
      state.productSubTypeListLoading = true
      state.addSubCategoryApiSuccess = false
    },

    addSubProductTypeListDataSuccess: (state, { payload }) => {
      state.updateSubTypeProductCategories = true
      state.productSubTypeListLoading = false
      state.addSubCategoryApiSuccess = true
      state.addSubCategoryError = payload?.payload
    },
    // first
    resetAddSubCategoryError: (state) => {
      //state.addSubCategoryError = '' // or [] to reset the errors
      state.addSubCategoryApiSuccess = false
    },
    addSubProductTypeListDataFailed: (state, { payload }) => {
      state.updateSubTypeProductCategories = false
      state.productSubTypeListLoading = true
      alert(payload)
    },
    getWearableSizesListApiData: (state, { payload }) => {
      state.errorMsg = ''
      state.getWearableSizesLoading = true
    },
    getWearableSizesListApiDataSuccess: (state, { payload }) => {
      state.getWearableSizesLoading = false
      state.wearableSizesList = payload?.payload?.data
    },
    getWearableSizesListApiDataFailed: (state, { payload }) => {
      state.getWearableSizesLoading = false
    },
    getProductTypeListApiData: (state, { payload }) => {
      state.productTypeListLoading = true
    },
    getProductTypeListApiDataSuccess: (state, { payload }) => {
      state.productTypeListLoading = false
      state.productTypeList = payload?.payload?.data
      state.productTypeListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getProductTypeListApiDataFailed: (state, { payload }) => {
      state.productTypeListLoading = false
    },
    getDrugCompositionListApiData: (state, { payload }) => {
      state.drugCompositionListLoading = true
    },
    getDrugCompositionListApiDataSuccess: (state, { payload }) => {
      state.drugCompositionListLoading = false
      state.drugCompositionList = payload?.payload?.data
      state.drugCompositionListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getDrugCompositionListApiDataFailed: (state, { payload }) => {
      state.drugCompositionListLoading = false
    },
    addDrugCompositionApiData: (state, { payload }) => {
      state.updateDrugCompositionsList = false
    },
    addDrugCompositionApiDataSuccess: (state, { payload }) => {
      state.updateDrugCompositionsList = true
    },
    addDrugCompositionApiDataFailed: (state, { payload }) => {
      state.updateDrugCompositionsList = false
    },
    updateSubTypeProductData: (state, { payload }) => {
      state.addSubCategoryApiSuccess = true
      state.productSubTypeList = state.productSubTypeList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
      //state.updateSubTypeProductCategories = false
    },
    updateSubTypeProductDataSuccess: (state, { payload }) => {
      state.addSubCategoryApiSuccess = true
      state.addSubCategoryError = payload?.payload
    },
    updateSubTypeProductDataFailed: (state, { payload }) => {
      state.updateSubTypeProductCategories = false
    },
    updateDrugCompositionDataSuccess: (state, { payload }) => {
      state.updateDrugCompositionsList = true
    },
    updateDrugCompositionDataFailed: (state, { payload }) => {},

    updateDrugCompositionData: (state, { payload }) => {
      state.drugCompositionList = state.drugCompositionList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    deleteDrugCompositionsDataSuccess: (state, { payload }) => {
      state.updateDrugCompositionsList = true
    },
    deleteDrugCompositionsDataFailed: (state, { payload }) => {},
    deleteDrugCompositionsData: (state, { payload }) => {
      let updatedDoctorList = state.drugCompositionList?.filter((item) => item.id !== payload?.id)
      state.drugCompositionList = updatedDoctorList
      state.updateDrugCompositionsList = false
    },
    // get List Complaint Data
    getListComplaintCategoriesData: (state, { payload }) => {},
    getListComplaintCategoriesDataSuccess: (state, { payload }) => {},
    getListComplaintCategoriesDataFailed: (state, { payload }) => {},
    //get list Suggestain Data
    getListSuggestionsCategoriesData: (state, { payload }) => {},
    getListSuggestionsCategoriesDataSuccess: (state, { payload }) => {},
    getListSuggestionsCategoriesDataFailed: (state, { payload }) => {},
    // get product List Category
    getListProductCategoryData: (state, { payload }) => {
      state.listProductCategoriesLoading = true
    },
    getListProductCategoryDataSuccess: (state, { payload }) => {
      state.listProductCategoriesLoading = false
      state.listProductCategories = payload?.payload?.data
      state.listProductCategoriesPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },

    // add Product By Excel
    addProductByExcelApiData: (state, { payload }) => {
      // state.pharmacyExcelLoading
      state.pharmacyProductExcelLoading = true
      state.excelApiCallSuccess = false
    },
    addProductByExcelApiSucees: (state, { payload }) => {
      // state.pharmacyExcelLoading
      state.pharmacyProductExcelLoading = false
      state.excelApiCallSuccess = true
      state.excelProductError = payload?.payload?.errors || []
    },
    resetExcelError: (state) => {
      state.excelProductError = [] // or [] to reset the errors
      state.excelApiCallSuccess = false
      state.excelBulkPharmacyError = []
      state.pharmacyExcelApiCallSuccess = false
    },
    addProductByExcelApiFailed: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },

    // Add Pharmacy By Excel through Admin
    addPharmacyByExcelApiData: (state, { payload }) => {
      state.bulkPharmacyExcelLoading = true
      state.pharmacyExcelApiCallSuccess = false
    },
    addPharmacyByExcelApiSucees: (state, { payload }) => {
      state.bulkPharmacyExcelLoading = false
      state.pharmacyExcelApiCallSuccess = true
      state.excelBulkPharmacyError = payload?.payload?.errors || []
    },
    addPharmacyByExcelApiFailed: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },

    getListProductCategoryDataFailed: (state, { payload }) => {},
    // add product Category
    addProductCategoryData: (state, { payload }) => {
      state.updateListProductCategory = false
      state.addCategoryApiSuccess = false
    },
    addProductCategoryDataSuccess: (state, { payload }) => {
      state.updateListProductCategory = true
      state.addCategoryError = payload.payload
      state.addCategoryApiSuccess = true
    },

    resetAddCategoryError: (state) => {
      //state.addCategoryError = '' // or [] to reset the errors
      state.addCategoryApiSuccess = false
    },
    addProductCategoryDataFailed: (state, { payload }) => {},
    // update product Category data
    updateProductCategoryData: (state, { payload }) => {
      state.addCategoryApiSuccess = false
      state.listProductCategories = state.listProductCategories?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateProductCategoryDataSuccess: (state, { payload }) => {
      state.addCategoryError = payload.payload
      state.addCategoryApiSuccess = true
    },
    updateProductCategoryDataFailed: (state, { payload }) => {},
    // delete product Category data
    deleteProductCategoryData: (state, { payload }) => {
      let updatedDoctorList = state.listProductCategories?.filter((item) => item.id !== payload?.id)
      state.listProductCategories = updatedDoctorList
      state.updateListProductCategory = false
    },
    deleteProductCategoryDataSuccess: (state, { payload }) => {
      state.updateListProductCategory = true
    },
    deleteProductCategoryDataFailed: (state, { payload }) => {},
    // delete product sub type category data
    deleteProductSubTypeData: (state, { payload }) => {
      let updatedProductSubTypeList = state.productSubTypeList?.filter(
        (item) => item.id !== payload?.id,
      )
      state.productSubTypeList = updatedProductSubTypeList
      state.updateSubTypeProductCategories = true
    },
    deleteProductSubTypeDataSuccess: (state, { payload }) => {
      state.updateSubTypeProductCategories = false
    },
    deleteProductSubTypeDataFailed: (state, { payload }) => {},
    // Add product data

    addProductData: (state, { payload }) => {
      state.adminAddProductLoading = true
    },
    addProductDataSuccess: (state, { payload }) => {
      state.adminAddProductLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    addProductDataFailed: (state, { payload }) => {
      // state.adminAddProductLoading = false

      alert(JSON.stringify(payload, null, 2))
    },
    // get product Data
    getListProductDataSuccess: (state, { payload }) => {
      state.ListProductDataLoding = false
      state.dataProductList = payload?.payload?.data
      state.dataProductListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getListProductData: (state, { payload }) => {
      state.ListProductDataLoding = true
    },
    getListProductDataFailed: (state, { payload }) => {},
    // list Product details
    getListProductDetailsData: (state, { payload }) => {},
    getListProductDetailsDataFailed: (state, { payload }) => {},
    getListProductDetailsDataSuccess: (state, { payload }) => {},
    // List Order Medicine
    getOrderPharmacyListApiData: (state, { payload }) => {
      state.getOrderPharmacyListLoading = true
    },
    getOrderPharmacyListDataSuccess: (state, { payload }) => {
      state.getOrderPharmacyListLoading = false
      state.getOrderPharmacyList = payload?.payload?.data
      state.getOrderPharmacyListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getOrderPharmacyListDataFailed: (state, { payload }) => {
      state.getOrderPharmacyListLoading = true
    },
    //  Each Order PharmacyListData
    getEachPharmacyOrderListData: (state, { payload }) => {
      state.getEachOrderDetailsLoading = true
    },
    getEachPharmacyOrderListDataSuccess: (state, { payload }) => {
      state.getEachOrderDetails = payload?.payload?.data
      state.getEachOrderDetailsLoading = false
    },
    getEachPharmacyOrderListDataFailed: (state, { payload }) => {},
    // get product Details
    getProductDeatilsApiData: (state, { payload }) => {
      state.getProductDeatilsLoading = true
    },
    getProductDeatilsDataSuccess: (state, { payload }) => {
      state.getProductDeatils = payload?.payload?.data
      state.getProductDeatilsLoading = false
    },
    getProductDeatilsFailed: (state, { payload }) => {
      state.getProductDeatilsLoading = true
    },
    // get Pharmacy Details
    getPharmacyDetailsListApiData: (state, { payload }) => {},
    getPharmacyDetailsListApiSuccess: (state, { payload }) => {
      state.pharmacyDetailsList = payload?.payload?.data
    },
    getPharmacyDetailsListApiFailed: (state, { payload }) => {},
    // Add product Type
    addProductTypeListListApiSuccess: (state, { payload }) => {
      state.updateProductTypes = true
      state.addProductTypeError = payload.payload
      state.addProductTypeApiSuccess = true
    },

    resetAddProductTypeError: (state) => {
      // state.addProductTypeError = '' // or [] to reset the errors
      state.addProductTypeApiSuccess = false
    },
    addProductTypeListListApiFailed: (state, { payload }) => {
      state.updateProductTypes = false
      state.addProductTypeApiSuccess = false
      alert(JSON.stringify(payload))
    },
    addProductTypeListListApiData: (state, { payload }) => {
      state.updateProductTypes = false
      state.addProductTypeApiSuccess = false
    },
    // update product Type
    updateProductTypeListApiSuccess: (state, { payload }) => {
      state.addProductTypeError = payload.payload
      state.addProductTypeApiSuccess = true
    },
    updateProductTypeListApiFailed: (state, { payload }) => {
      //state.updateProductTypes = false
    },
    updateProductTypeListApiData: (state, { payload }) => {
      state.addProductTypeApiSuccess = false

      state.productTypeList = state.productTypeList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    // getProductDetails
    getProductTypeDetailsApiData: (state, { payload }) => {
      state.productTypeDetailsListLoading = true
    },
    getProductTypeDetailsApiSuccess: (state, { payload }) => {
      state.productTypeDetailsList = payload?.payload?.data
      state.productTypeDetailsListLoading = false
    },
    getProductTypeDetailsApiFailed: (state, { payload }) => {
      alert(JSON.stringify(payload))
    },

    // get Product Category details
    getProductCategoryDetailsApiData: (state, { payload }) => {
      state.productCategoryDetailsListLoading = true
    },
    getProductCategoryDetailsApiSuccess: (state, { payload }) => {
      state.productCategoryDetailsListLoading = false
      state.productCategoryDetailsList = payload?.payload?.data
    },
    getProductCategoryDetailsApiFailed: (state, { payload }) => {
      alert(JSON.stringify(payload))
    },

    // get Sub Category Details
    getProductSubCategoryDetailsApiData: (state, { payload }) => {
      state.productSubCategoryDetailsListLoading = true
    },
    getProductSubCategoryDetailsApiSuccess: (state, { payload }) => {
      state.productSubCategoryDetailsList = payload?.payload?.data
      state.productSubCategoryDetailsListLoading = false
    },

    // get All Product List
    getallProductListApiData: (state, { payload }) => {
      state.getAllProductListLoading = true
      state.getAllProductListSuccess = false
    },
    getallProductListApiSucees: (state, { payload }) => {
      state.getAllProductListLoading = false
      state.getAllProductListSuccess = true
      state.getAllProductList = payload?.payload?.data
    },
    getallProductListApiFailed: (state, { payload }) => {},
    getProductSubCategoryDetailsFailed: (state, { payload }) => {},
    // delete Product type
    deleteProductTypeListApiSuccess: (state, { payload }) => {},
    deleteProductTypeListApiFailed: (state, { payload }) => {},
    deleteProductTypeListApiData: (state, { payload }) => {
      let updatedProductList = state.productTypeList?.filter((item) => item.id !== payload?.id)
      state.productTypeList = updatedProductList
      //state.updateListProductCategory = false
    },

    // Update product Details
    updateProductApiData: (state, { payload }) => {
      state.addProductTypeApiSuccess = false

      state.dataProductList = state.dataProductList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateProductSucees: (state, { payload }) => {
      state.updateProductTypeError = payload.payload
      state.updateProductListSuccess = true
    },
    resetUpdateProductError: (state, { payload }) => {
      // state.updateProductTypeError = ''
      state.updateProductListSuccess = false
    },
    updateProductFailed: (state, { payload }) => {
      //state.updateProductTypeError = payload.payload
      alert(JSON.stringify(payload))
      //state.updateProductListSuccess = true
    },
    // product Details Change Status
    productStatusChangeApiData: (state, { payload }) => {
      state.updateProductStatus = false
    },
    productStatusChangeApiSucees: (state, { payload }) => {
      state.updateProductStatus = true
    },
    productStatusChangeApiFailed: (state, { payload }) => {},

    // medicine
    //  Add Medicine Product
    addMedicineProductData: (state, { payload }) => {
      state.addMedicineProductLoading = true
    },
    addMedicineProductApiSuccess: (state, { payload }) => {
      state.addMedicineProductLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    addMedicineProductApiFailed: (state, { payload }) => {
      state.addMedicineProductLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // getMedicineProductList
    getMedicineProductListData: (state, { payload }) => {
      state.productMedicineListLoading = true
    },
    getMedicineProductListApiSuccess: (state, { payload }) => {
      state.productMedicineListLoading = false
      state.productMedicineList = payload?.payload?.data
      state.productMedicineListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getMedicineProductListApiFailed: (state, { payload }) => {
      state.productMedicineListLoading = false
      alert(JSON.stringify(payload))
    },

    // getMedicineDetails
    getMedicineDetailsData: (state, { payload }) => {
      state.productMedicineDetailsListLoading = true
    },
    getMedicineDetailsApiSucees: (state, { payload }) => {
      state.productMedicineDetailsListLoading = false
      state.productMedicineDetails = payload?.payload?.data
    },
    getMedicineDetailsApiFailed: (state, { payload }) => {
      state.productMedicineDetailsListLoading = false
      alert(JSON.stringify(payload))
    },
    resetError: (state) => {
      state.ApiError = ''
      state.modalOpen = false
    },
  },
})

export const {
  // pharmacy Admin
  getSubProductTypeListData,
  getSubProductTypeListSuccess,
  getSubProductTypeListFailed,

  // add Pharmacy sub categories
  addSubProductTypeListDataSuccess,
  addSubProductTypeListDataFailed,
  addSubProductTypeListData,
  // get Wearable Sizes
  getWearableSizesListApiData,
  getWearableSizesListApiDataSuccess,
  getWearableSizesListApiDataFailed,
  // List Product type
  getProductTypeListApiDataSuccess,
  getProductTypeListApiDataFailed,
  getProductTypeListApiData,
  // List Drug Composition
  getDrugCompositionListApiData,
  getDrugCompositionListApiDataSuccess,
  getDrugCompositionListApiDataFailed,
  // Add List Drug Compositions
  addDrugCompositionApiData,
  addDrugCompositionApiDataSuccess,
  addDrugCompositionApiDataFailed,

  // Update Sub Product Data
  updateSubTypeProductData,
  updateSubTypeProductDataSuccess,
  updateSubTypeProductDataFailed,
  // update drug composition
  updateDrugCompositionDataSuccess,
  updateDrugCompositionDataFailed,
  updateDrugCompositionData,
  // delete drug Compositions
  deleteDrugCompositionsDataSuccess,
  deleteDrugCompositionsDataFailed,
  deleteDrugCompositionsData,
  // get List Complaint Data
  getListComplaintCategoriesData,
  getListComplaintCategoriesDataSuccess,
  getListComplaintCategoriesDataFailed,
  //get list Suggestain Data
  getListSuggestionsCategoriesData,
  getListSuggestionsCategoriesDataSuccess,
  getListSuggestionsCategoriesDataFailed,
  // get product List Category
  getListProductCategoryData,
  getListProductCategoryDataSuccess,
  getListProductCategoryDataFailed,
  // add product Category
  addProductCategoryData,
  addProductCategoryDataSuccess,
  addProductCategoryDataFailed,
  // update product Category data
  updateProductCategoryData,
  updateProductCategoryDataSuccess,
  updateProductCategoryDataFailed,
  // delete product Category data
  deleteProductCategoryData,
  deleteProductCategoryDataSuccess,
  deleteProductCategoryDataFailed,
  // delete product sub type category data
  deleteProductSubTypeData,
  deleteProductSubTypeDataSuccess,
  deleteProductSubTypeDataFailed,
  // Add product data
  addProductData,
  addProductDataSuccess,
  addProductDataFailed,
  // get product Data
  getListProductDataSuccess,
  getListProductData,
  getListProductDataFailed,
  // list Product details
  getListProductDetailsData,
  getListProductDetailsDataFailed,
  getListProductDetailsDataSuccess,

  // list PharmacyOrder List
  getOrderPharmacyListApiData,
  getOrderPharmacyListDataSuccess,
  getOrderPharmacyListDataFailed,
  //  Each Order PharmacyListData
  getEachPharmacyOrderListData,
  getEachPharmacyOrderListDataSuccess,
  getEachPharmacyOrderListDataFailed,
  // get product Details
  getProductDeatilsApiData,
  getProductDeatilsDataSuccess,
  getProductDeatilsFailed,
  // get Pharmacy Details
  getPharmacyDetailsListApiData,
  getPharmacyDetailsListApiSuccess,
  getPharmacyDetailsListApiFailed,
  // Add product Type
  addProductTypeListListApiSuccess,
  addProductTypeListListApiFailed,
  addProductTypeListListApiData,
  // update product Type
  updateProductTypeListApiSuccess,
  updateProductTypeListApiFailed,
  updateProductTypeListApiData,
  // delete Product type
  deleteProductTypeListApiSuccess,
  deleteProductTypeListApiFailed,
  deleteProductTypeListApiData,
  // getProductDetails
  getProductTypeDetailsApiData,
  getProductTypeDetailsApiSuccess,
  getProductTypeDetailsApiFailed,
  // get Product Category details
  getProductCategoryDetailsApiData,
  getProductCategoryDetailsApiSuccess,
  getProductCategoryDetailsApiFailed,

  // get Sub Category Details
  getProductSubCategoryDetailsApiData,
  getProductSubCategoryDetailsApiSuccess,
  getProductSubCategoryDetailsFailed,
  // add Product By Excel
  addProductByExcelApiData,
  resetExcelError,
  addProductByExcelApiSucees,
  addProductByExcelApiFailed,
  // get All Product List
  getallProductListApiData,
  getallProductListApiSucees,
  getallProductListApiFailed,

  // Update product Details
  updateProductApiData,
  updateProductSucees,
  updateProductFailed,

  // product Details Change Status
  productStatusChangeApiData,
  productStatusChangeApiSucees,
  productStatusChangeApiFailed,
  //

  //  Add Medicine Product
  addMedicineProductData,
  addMedicineProductApiSuccess,
  addMedicineProductApiFailed,

  // getMedicineProductList
  getMedicineProductListData,
  getMedicineProductListApiSuccess,
  getMedicineProductListApiFailed,

  // getMedicineDetails
  getMedicineDetailsData,
  getMedicineDetailsApiSucees,
  getMedicineDetailsApiFailed,

  // Add Pharmacy By Excel through Admin
  addPharmacyByExcelApiData,
  addPharmacyByExcelApiSucees,
  addPharmacyByExcelApiFailed,

  resetAddProductTypeError,
  resetAddSubCategoryError,
  resetAddCategoryError,
  resetUpdateProductError,
  resetError,
} = slice.actions

export default slice.reducer
